import { useMutation } from "@tanstack/react-query";
import { api } from "../../libs/axios";
import { queryClient } from "../../libs/queryClient";

export function useMutationPix(id: string, isFatura = false) {
  return useMutation({
     mutationFn: async () => {
      const response = await api.post(isFatura ? `checkout/pix/fatura/${id}` : `/checkout/pix/${id}`);

      return response.data;
    },
    onError() {
        queryClient.invalidateQueries({
          queryKey: ['pedido'],
          exact: false,
        })
    },
  });
}